module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUBAMAAADxfUlCAAAAG1BMVEXOESbOEifTKTzcU2Lmh5Hvs7r55Ob++/z////tEnMkAAAAHUlEQVQY02PoAIIUBQYkABLpKDUkKIKpa9QcnLoAH+c7dTUtPvsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/bh.png
// module id = 240
// module chunks = 0